import styled from "@emotion/styled";
import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import ChangePassword from "./ChangePassword";
import Users from "./Users";

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  boxShadow: theme.shadows[6],
  borderRadius: theme.spacing(1),
  height: "100%",
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.custom.secondary,
    height: 4,
  },
}));

const Setting = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "0 auto",
        padding: "2rem",
        borderRadius: "10px",
        overflow: "hidden",
        position: "relative",
        zIndex: 1,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <Box mb={3}>
        <Typography variant="f32">Setting</Typography>
      </Box>

      <>
        <StyledCard>
          <StyledTabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="forecast tabs"
          >
            <Tab label="Change Password" />
            <Tab label="Users" />
          </StyledTabs>

          <Box py={3}>
            {tabIndex === 0 && (
              <Box>
                <ChangePassword />
              </Box>
            )}
            {tabIndex === 1 && (
              <Box>
                <Users />
              </Box>
            )}
          </Box>
        </StyledCard>
      </>
    </Box>
  );
};

export default Setting;
